import React from "react";
import { Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

interface DialogHeaderProps {
    children?: React.ReactNode;
    onClose: () => void;
}

export const DialogHeader = (props: DialogHeaderProps) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            paddingRight="24px"
            paddingBottom="20px"
        >
            <div>{props.children}</div>
            <IconButton onClick={props.onClose}>
                <Close />
            </IconButton>
        </Box>
    );
};
